import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _lastIndexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/last-index-of";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import BrowserMixin from "../../../shared/utils/application-mixins/browser-mixin";
import InlinePrompt from "../../../shared/components/general/inline-prompt";
import { get } from "lodash";
import InputRequiredIndicator from "../general/input-required-indicator.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "Field",
  components: {
    InlinePrompt,
    InputRequiredIndicator
  },
  mixins: [BrowserMixin],
  inject: {
    $validator: {
      default: null
    }
  },
  provide() {
    if (this.validation) {
      return {
        $validator: {
          value: this.validation
        },
        $rootValidator: this.$validator
      };
    }
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    containerClass: {
      type: String,
      default: ""
    },
    sizeClass: {
      type: String,
      default: ""
    },
    removable: {
      type: Boolean,
      default: false
    },
    removePath: {
      type: String,
      default: ""
    },
    longTitle: {
      type: Boolean,
      default: false
    },
    sideLabel: {
      type: Boolean,
      default: false
    },
    sideLabelSize: {
      type: String,
      default: ""
    },
    calculated: {
      type: Boolean,
      default: false
    },
    autoCalculated: {
      type: Boolean,
      default: true
    },
    titleClass: {
      type: String,
      default: ""
    },
    editVisibility: {
      type: Boolean,
      default: false
    },
    visibilityPaths: {
      type: Array,
      default: null
    },
    hideEye: {
      type: Boolean,
      default: false
    },
    dependsUpon: {
      type: Array,
      default: null
    },
    clickableTitle: {
      type: Boolean,
      default: false
    },
    iconTooltip: {
      type: String,
      default: ""
    },
    transition: {
      type: Boolean,
      default: true
    },
    transitionName: {
      type: String,
      default: "slide-fade"
    },
    icon: {
      type: String,
      default: ""
    },
    path: {
      type: String,
      default: null
    },
    translationMap: {
      type: Object,
      default: null
    },
    customExpression: {
      type: String,
      default: null
    },
    validatorContext: {
      type: Object,
      default: null
    },
    overlay: {
      type: Boolean,
      default: false
    },
    hideRequiredIndicator: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visibilityText: {
        hidden: this.$t("settings.applicationForm.hiddenSection"),
        visible: this.$t("settings.applicationForm.visibleSection")
      },
      mandatoryText: {
        required: this.$t("settings.applicationForm.requiredInput"),
        optional: this.$t("settings.applicationForm.optionalInput")
      },
      groupIndex: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("ApplicationStore", ["fieldIsVisible", "fieldIsRequired"])), {}, {
    isVisible() {
      if (!this.visibilityPaths) return true;
      return this.fieldIsVisible({
        paths: this.visibilityPaths,
        title: this.title
      });
    },
    isRequired() {
      if (!this.visibilityPaths) return true;
      return this.fieldIsRequired({
        paths: this.visibilityPaths,
        title: this.title
      });
    },
    dependsUponVisible() {
      if (!this.dependsUpon) return true;
      return this.fieldIsVisible({
        paths: this.dependsUpon,
        title: this.title
      });
    },
    eyeTooltipTitle() {
      const option = this.isVisible ? "visible" : "hidden";
      return this.visibilityText[option];
    },
    mandatoryTooltipTitle() {
      const option = this.isRequired ? "required" : "optional";
      return this.mandatoryText[option];
    },
    computedSizeClass() {
      const classes = ["form-container", this.sizeClass];
      if (!this.recommendedBrowser()) {
        var _context;
        this.sizeClass.replace("col ", "");
        classes.push("no-flex-col", "col-auto ");
        if (_includesInstanceProperty(_context = this.sizeClass).call(_context, "-12")) classes.push("w-100");
      }
      if (this.sideLabel) classes.push("form-container-side-label");
      return classes.join(" ");
    },
    pathToUse() {
      var _this$visibilityPaths;
      if (!this.path && !this.visibilityPaths) return "";
      if (this.path) return this.path;
      const firstVisibilityPath = (_this$visibilityPaths = this.visibilityPaths) == null ? void 0 : _this$visibilityPaths[0];

      // It's necessary to add the index ( if present ), to the last instance of "][" on the path
      // i.e path -> main-applicant[liabilities][amount], with index would be -> main-applicant[liabilities][0][amount]
      const positionToAddString = _lastIndexOfInstanceProperty(firstVisibilityPath).call(firstVisibilityPath, "][") + 1;
      const visibilityPathWithIndex = firstVisibilityPath ? [_sliceInstanceProperty(firstVisibilityPath).call(firstVisibilityPath, 0, positionToAddString), `[${this.groupIndex}]`, _sliceInstanceProperty(firstVisibilityPath).call(firstVisibilityPath, positionToAddString)].join("") : null;
      return this.groupIndex ? visibilityPathWithIndex : firstVisibilityPath;
    },
    hashId() {
      return this.$options.filters.hashId(this.pathToUse);
    },
    validation() {
      if (this.validatorContext) {
        return get(this.validatorContext, this.customExpression) || {};
      }
      if (!this.$validator) return null;
      if (this.pathToUse) {
        const validationPath = this.pathToUse.replace(/\[(\d*)\]/g, "[$each][$1]");
        return get(this.$validator.value.applicationValidationsModel, validationPath) || {};
      }
      return {};
    },
    isValidationRequired() {
      var _this$validation, _this$validation$$par;
      return !!((_this$validation = this.validation) != null && (_this$validation$$par = _this$validation.$params) != null && _this$validation$$par.required);
    }
  }),
  mounted() {
    var _this$$el;
    const mandatory = this.$refs.mandatory;
    const informationTooltip = this.$refs.informationTooltip;
    const eye = this.$refs.eye;
    if (mandatory && eye) {
      $(mandatory).tooltip();
      $(eye).tooltip();
    }
    if (this.iconTooltip) {
      $(informationTooltip).tooltip();
    }
    this.groupIndex = ((_this$$el = this.$el) == null ? void 0 : _this$$el.parentElement.getAttribute("group-index")) || null;
  },
  updated() {
    this.$nextTick(() => {
      const mandatory = this.$refs.mandatory;
      const eye = this.$refs.eye;
      if (mandatory && eye) {
        $(mandatory).tooltip();
        $(eye).tooltip();
      }
    });
  },
  methods: {
    toggleVisibility() {
      this.$emit("toggle-visibility", {
        paths: this.visibilityPaths,
        isVisible: this.isVisible
      });
    },
    toggleValidation() {
      this.$emit("toggle-visibility", {
        paths: this.visibilityPaths,
        isRequired: this.isRequired
      });
    },
    remove() {
      this.$emit("remove", this.removePath);
    },
    getTitleClass() {
      const classes = ["form-title", this.$props.titleClass];
      if (this.calculated) classes.push("text-success");
      if (this.longTitle) classes.push("font-sm");
      if (this.clickableTitle) classes.push("text-primary clickable");
      classes.push("font-sm");
      classes.push(this.sideLabel ? "m-0 text-left" : "mb-0");
      return classes.join(" ");
    },
    handleClick() {
      if (!this.clickableTitle) return;
      this.$emit("navigate");
    }
  }
});